// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"70":"fd1a434a255ad0339917","98":"20decf15b099c291b660","508":"88f72ce218618603308d","742":"6c3f0459aef413523d67"}[chunkId] + ".js";
};